import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Box from "@mui/material/Box";
import Thongkephuongtientable from "components/Thongke/Dangkiem/Thongkephuongtientable.js";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const cbccolumn = [
  {
    field: "stt",
    headerName: "stt",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "ten",
    headerName: "Đơn vị",
    width: 460,
    headerAlign: "center",
  },
];
const loaibaocao = [
  { id: "1", ten: "Đã báo cáo" },
  { id: "2", ten: "Chưa báo cáo" },
];
export default function Dangkiemthongkephuongtien() {
  const [pageSize, setPageSize] = React.useState(50);
  const [phuongtien, setPhuongtien] = React.useState([]);
  const [tuthang, setTuthang] = React.useState(dayjs());
  const [denthang, setDenthang] = React.useState(dayjs());
  const [donvi, setDonvi] = React.useState([]);
  const [donvivalue, setDonvivalue] = React.useState(null);
  const [chuabaocao, setChuabaocao] = React.useState([]);
  const [loaibaocaoVL, setLoaibaocaoVL] = React.useState({
    id: "1",
    ten: "Đã báo cáo",
  });
  const [dabaocao, setDabaocao] = React.useState(1);
  const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getdonvi = () => {
    var url =
      Config.backend + "/api/Donvi/gettrungtamdangkiemall?username" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        const newData = [{ id: 0, ten: "Tất cả" }, ...data];
        setDonvi(newData);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getbaocao = () => {
    var tu = String(tuthang.$M + 1).padStart(2, "0") + "/" + tuthang.$y;
    var den = String(denthang.$M + 1).padStart(2, "0") + "/" + denthang.$y;
    var url =
      Config.backend +
      "/api/Baocao/getslphuluc14theokhoangtgdonvibc?tuthang=" +
      tu +
      "&denthang=" +
      den +
      "&trungtamdangkiem_id=" +
      donvivalue +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhuongtien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getchuabaocao = () => {
    var tu = String(tuthang.$M + 1).padStart(2, "0") + "/" + tuthang.$y;
    var den = String(denthang.$M + 1).padStart(2, "0") + "/" + denthang.$y;
    var url =
      Config.backend +
      "/api/BaoCao/tkchuabaocaokhoangtgphuluc14?tuthang=" +
      tu +
      "&denthang=" +
      den +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setChuabaocao(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getdonvi();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Từ tháng"
              value={tuthang}
              onChange={(newValue) => setTuthang(newValue)}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "32px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "15%", marginLeft: 10 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Đến tháng"
              value={denthang}
              onChange={(newValue) => setDenthang(newValue)}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "32px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "20%", marginLeft: 10 }}>
          <Autocomplete
            freeSolo
            disableClearable
            size="small"
            options={loaibaocao}
            value={loaibaocaoVL}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              setLoaibaocaoVL(value);
              setDabaocao(value.id);
              if (value.id === "2") {
                setDabaocao(2);
                setDisableBT(true);
                getchuabaocao();
              } else {
                setDabaocao(1);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Loại báo cáo"
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "28%", marginLeft: 10 }}>
          <Autocomplete
            freeSolo
            disabled={dabaocao === 1 ? false : true}
            disableClearable
            size="small"
            options={donvi}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              setDisableBT(false);
              setDonvivalue(value.id);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn đơn vị"
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            disabled={disableBT}
            style={{ height: 32 }}
            onClick={getbaocao}
          >
            Xem
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        {dabaocao === 1 && (
          <div style={{ height: 500, width: "100%", marginTop: 10 }}>
            <Thongkephuongtientable phuongtien={phuongtien} />
          </div>
        )}
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        {dabaocao === 2 && (
          <div style={{ height: 500, width: "100%", marginTop: 10 }}>
            <DataGrid
              getRowId={(row) => row.stt}
              rows={chuabaocao}
              columns={cbccolumn}
              checkboxSelection={false}
              getRowHeight={() => "auto"}
              headerHeight={35}
              sx={datagridSx}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[20, 50, 100]}
              pagination
              initialState={{
                filter: {
                  filterModel: {
                    items: [],
                    quickFilterLogicOperator: GridLinkOperator.Or,
                  },
                },
              }}
              components={{ Toolbar: quickSearchToolbar }}
            />
          </div>
        )}
      </GridItem>
    </GridContainer>
  );
}
